var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ModalBody",on:{"click":(event) => event.stopPropagation()}},[_c('div',{staticClass:"Overlay"}),_c('div',{staticClass:"ModalContent",staticStyle:{"width":"720px"}},[_c('h5',[_vm._v("Mensaje derivacion")]),_c('div',{staticClass:"textContainer"}),_c('div',{staticClass:"containerButtons"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }